import { useState, useEffect } from 'react';
import api from '../../services/api';
import { Load } from '../../components/Load';
import { Header } from '../../components/Header';
import { Select, Options } from '../../components/Select';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { CardContent } from '../../components/CardContent';
import { Col, Row, Pagination, Button, Form } from 'react-bootstrap';
import { Table, TBody, TCell, TGroup, THeader, TRow, ThCell } from '../../components/Table/Table';
import { Title } from '../../components/Title';
import './style.css';
import { useNavigate } from 'react-router-dom';
import ChartsSection from '../../components/ChartsRepresentante';

export function ResumoVendasRepresentantes() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);

    const [resumoRepresentantes, setResumoRepresentantes]: any = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [employeesPerPage, setEmployeesPerPage] = useState(20);
    const [employeesPerPageOptions] = useState([5, 10, 15, 20, 50, 100]);

    const [searchQuery, setSearchQuery] = useState('');
    const [currentFilteredEmployees, setCurrentFilteredEmployees] = useState([]);

    // Calcula o índice do primeiro e do último funcionário na página atual
    const indexOfLastEmployee = currentPage * employeesPerPage;
    const indexOfFirstEmployee = indexOfLastEmployee - employeesPerPage;

    // const currentEmployees = resumoRepresentantes.slice(indexOfFirstEmployee, indexOfLastEmployee);

    const [show, setShow] = useState(false);
    const [idSelected, setIdSelected] = useState('');

    const showModal = (id: any) => {
        setIdSelected(id)
        setShow(true)
    }


    const loadResume = async () => {
        try {
            const response = await api.post('listar-resumo-representante')

            const resumoRepresentantes = response.data.data.map((resumo: any) => {
                const totalPagamento = resumo.pgrPedidos.pgrPagamentos.total;
                const porcentagemCredenciado = resumo.pgrCredenciado.porcentagem_comissao;
                const porcentagemRepresentante = resumo.pgrRepresentanteDeVendas.porcentagem_comissao;

                const valorCredenciado = totalPagamento * (porcentagemCredenciado / 100);
                const valorRepresentante = valorCredenciado * (porcentagemRepresentante / 100);

                return {
                    ...resumo,
                    valorCredenciado,
                    valorRepresentante
                };
            });

            setResumoRepresentantes(resumoRepresentantes);
        } catch (error) {
            console.error("Error fetching employees:", error);
        }
    };


    const handleEmployeesPerPageChange = (value: any) => {
        setEmployeesPerPage(Number(value));
        setCurrentPage(1); // Volta para a primeira página ao mudar a quantidade por página
    };

    useEffect(() => {
        loadResume();
    }, []);

    useEffect(() => {
        const indexOfLastFilteredEmployee = currentPage * employeesPerPage;
        const indexOfFirstFilteredEmployee = indexOfLastFilteredEmployee - employeesPerPage;
        const newCurrentFilteredEmployees = resumoRepresentantes.slice(indexOfFirstFilteredEmployee, indexOfLastFilteredEmployee);

        setCurrentFilteredEmployees(newCurrentFilteredEmployees);
    }, [currentPage, employeesPerPage, resumoRepresentantes]);

    /*paginação*/
    const paginationItems = () => {
        let items = [];
        const totalPaginas = Math.ceil(resumoRepresentantes.length / employeesPerPage);

        // Primeira página
        if (currentPage > 2) {
            items.push(
                <Pagination.Item
                    key="first"
                    onClick={() => setCurrentPage(1)}
                >
                    1
                </Pagination.Item>
            );
        }

        // Reticências antes da página atual, se necessário
        if (currentPage > 3) {
            items.push(<Pagination.Ellipsis key="startEllipsis" disabled />);
        }

        // Página anterior à atual, se aplicável
        if (currentPage > 1) {
            items.push(
                <Pagination.Item
                    key={currentPage - 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                >
                    {currentPage - 1}
                </Pagination.Item>
            );
        }

        // Página atual
        items.push(
            <Pagination.Item
                key={currentPage}
                active
            >
                {currentPage}
            </Pagination.Item>
        );

        // Página seguinte à atual, se aplicável
        if (currentPage < totalPaginas) {
            items.push(
                <Pagination.Item
                    key={currentPage + 1}
                    onClick={() => setCurrentPage(currentPage + 1)}
                >
                    {currentPage + 1}
                </Pagination.Item>
            );
        }

        // Reticências depois da página atual, se necessário
        if (currentPage < totalPaginas - 2) {
            items.push(<Pagination.Ellipsis key="endEllipsis" disabled />);
        }

        // Última página
        if (currentPage < totalPaginas - 1) {
            items.push(
                <Pagination.Item
                    key="last"
                    onClick={() => setCurrentPage(totalPaginas)}
                >
                    {totalPaginas}
                </Pagination.Item>
            );
        }

        return items;
    };

    const getStatusDetails = (status: string) => {
        switch (status) {
            case 'P':
                return { color: 'orange', text: 'Pendente' };
            case 'R':
                return { color: 'blue', text: 'Em Revisão' };
            case 'RE':
                return { color: 'purple', text: 'Reembolsado' };
            case 'CB':
                return { color: 'red', text: 'Chargeback' };
            case 'C':
                return { color: 'grey', text: 'Cancelado' };
            case 'A':
                return { color: 'green', text: 'Aprovado' };
            default:
                return { color: 'black', text: 'Desconhecido' };
        }
    };

    const getPaymentTypeDescription = (tipo: string) => {
        switch (tipo) {
            case 'account_money':
                return 'Dinheiro na Conta';
            case 'credit_card':
                return 'Cartão de Crédito';
            case 'debit_card':
                return 'Cartão de Débito';
            case 'bank_transfer':
                return 'Transferência Bancária';
            case 'ticket':
                return 'Boleto';
            case 'P':
                return 'PIX';
        }
    };



    return (
        <div>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='./' />
            <Main>
                <CardContent>
                    <ChartsSection />
                </CardContent>
                <CardContent>
                    <Row className='my-4'>
                        <Title text="Vendas realizadas" />
                    </Row>
                    <Row className='mb-4'>
                        <Col sm={10} className='my-2 d-flex align-items-end'>
                            <span>Página {currentPage} de {Math.ceil(resumoRepresentantes.length / employeesPerPage)}</span>

                        </Col>
                        <Col sm={2} className='my-2 d-flex justify-content-end'>
                            <Select id='employeesPerPageSelect' onSelect={handleEmployeesPerPageChange}>
                                {employeesPerPageOptions.map((option) => (
                                    <Options
                                        key={option}
                                        value={option}
                                        name={`${option} por página`}
                                        selected={option === employeesPerPage}
                                    />
                                ))}
                            </Select>

                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div style={{ border: '1px solid #007bff', borderRadius: '6px', overflow: 'hidden', marginTop: '30px' }}>
                                <div style={{ overflow: 'auto' }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr style={{ backgroundColor: '#007bff', color: 'white', textAlign: 'center' }}>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '14px', fontWeight: 'normal' }}>
                                                    Cód
                                                </th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '14px', fontWeight: 'normal' }}>
                                                    Empresa
                                                </th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '14px', fontWeight: 'normal' }}>
                                                    Comissão à receber
                                                </th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '14px', fontWeight: 'normal' }}>
                                                    Forma de Pagamento
                                                </th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '14px', fontWeight: 'normal' }}>
                                                    Status
                                                </th>
                                                <th style={{ padding: '15px', textAlign: 'center', fontSize: '14px', fontWeight: 'normal' }}>
                                                    Comprovante
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {resumoRepresentantes.length > 0 ? (
                                                resumoRepresentantes.map((resumo: any) => (
                                                    <tr key={resumo.id} style={{ textAlign: 'center' }}>
                                                        <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '12px' }}>
                                                            {resumo.id}
                                                        </td>
                                                        <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '12px' }}>
                                                            {resumo.pgrEmpresa.nome}
                                                        </td>
                                                        <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '12px' }}>
                                                            R$ {resumo.valorRepresentante.toFixed(2)}
                                                        </td>
                                                        <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '12px' }}>
                                                            {getPaymentTypeDescription(resumo.pgrPedidos.pgrPagamentos.tipo)}
                                                        </td>
                                                        <td style={{ padding: '15px', textAlign: 'center', borderTop: '1px solid lightgray', fontSize: '12px', color: getStatusDetails(resumo.pgrPedidos.pgrPagamentos.status).color }}>
                                                            {getStatusDetails(resumo.pgrPedidos.pgrPagamentos.status).text}
                                                        </td>
                                                        <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '12px' }}>
                                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                                {resumo.comprovante_pagamento ? (
                                                                    <a href={`data:application/pdf;base64,${encodeURIComponent(resumo.comprovante_pagamento)}`} download="comprovante_pagamento.pdf">
                                                                        Baixar Comprovante
                                                                    </a>
                                                                ) : (
                                                                    'Sem Comprovante'
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={6} style={{ padding: '15px', textAlign: 'center', fontSize: '12px' }}>
                                                        Não há dados para serem mostrados
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Col>
                        <Col className='d-flex justify-content-center mt-4'>
                            <div className="pagination">
                                <Pagination>
                                    {paginationItems()}
                                </Pagination>
                            </div>
                        </Col>
                    </Row>
                </CardContent>
            </Main>
        </div >
    );
}